(() => {
	angular
		.module('main')
		.factory('ambassadorsDataService', ambassadorsDataService);

	ambassadorsDataService.$inject = ['$http', '$q'];

	function ambassadorsDataService($http, $q) {
		const AMBASSADOR_URL = '/admin/rest/ambassador';

		return {
			createAmbassador,
			getAmbassadors,
			getAmbassadorInfo,
			updateAmbassador
		};

		function getAmbassadors({
			perPage,
			page,
			pageOrder: { predicate, reverse },
			search
		}) {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: AMBASSADOR_URL,
				params: {
					perPage,
					page,
					predicate,
					reverse,
					search
				}
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function getAmbassadorInfo(id) {
			const deferred = $q.defer();

			$http({
				method: 'GET',
				url: `${AMBASSADOR_URL}/${id}`
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function createAmbassador(ambassador) {
			const deferred = $q.defer();

			$http({
				method: 'POST',
				url: AMBASSADOR_URL,
				data: ambassador
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}

		function updateAmbassador(ambassador) {
			const deferred = $q.defer();

			$http({
				method: 'PUT',
				url: AMBASSADOR_URL,
				data: ambassador
			})
				.then(
					response => {
						deferred.resolve(response.data);
					},
					response => {
						deferred.reject(response);
					}
				)
				.catch(response => {
					deferred.reject(response);
				});
			return deferred.promise;
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/services/dataServices/ambassadorsDataService.js